import { useMutation, useQueryClient } from "@tanstack/react-query";
import { declareDirectoryProtection } from "../openapi/api-client.ts";
import { operations } from "../openapi/generated-types.ts";

export const useDeclareDirectoryProtection = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: operations["directoryprotection.declare"]["requestBody"]["content"]["application/json"],
    ) => {
      return declareDirectoryProtection(body, {
        path: { projectId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["directoryProtections", { projectId }],
        }),
      ]);
    },
  });
};
